import request from '@/utils/request'
import qs from 'qs'
function  getParams(params) {
  // 清除参数无值的情况

  Object.keys(params).length !== 0 && Object.keys(params).forEach(item => {
    if (params[item] === null || params[item] === '') params[item] = undefined
  })
  return {
    ...params
  }
}
export function getMethod(url, params) {
  let urlnew=''
  if(params==undefined||params==null){
     urlnew=url
  }else {
    urlnew=url + '?' + qs.stringify(getParams(params), { indices: false })
  }
  return request({
    url: urlnew,
    method: 'get'
  })
}

export function download(url, params) {
  return request({
    url: url + '?' + qs.stringify(getParams(params), { indices: false }),
    method: 'get',
    responseType: 'blob'
  })
}
